"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TIME_DIFFERENCE = exports.DEFAULT_PUBLISH_AT_OFFSET = exports.TIMEPICKER_INTERVAL = exports.DATETIME_FORMAT = void 0;
var DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
exports.DATETIME_FORMAT = DATETIME_FORMAT;
var TIMEPICKER_INTERVAL = 30;
exports.TIMEPICKER_INTERVAL = TIMEPICKER_INTERVAL;
var DEFAULT_PUBLISH_AT_OFFSET = 24 * 60;
exports.DEFAULT_PUBLISH_AT_OFFSET = DEFAULT_PUBLISH_AT_OFFSET;
var DEFAULT_TIME_DIFFERENCE = 24 * 60;
exports.DEFAULT_TIME_DIFFERENCE = DEFAULT_TIME_DIFFERENCE;